import React, { useEffect } from 'react';
import RewardsAvailable from './RewardsAvailable';
import NoRewardsAvailable from './NoRewardsAvailable';
import { ApplicationState } from '../../../store';
import { useSelector, useDispatch } from 'react-redux';
import { loadLoyaltyWithdraw } from '../../../store/ducks/loyalty/actions';
import { Skeleton, Dialog } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import { ELoyaltyRoutes } from '../loyalty.routes';

const LoyaltyRewards: React.FC = () => {
  const now = new Date();
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const coinTotal = loyalty.rewards.total.total_coins;
  const areRewardsAvailable = () => {
    if (loyalty.withdraw.error === true || loyalty.withdraw.loading === true) {
      return false;
    } else {
      const activateDate = new Date(
        loyalty.withdraw.body.activate_date
      ).getDate();
      if (now.getDate() >= activateDate && coinTotal > 0) {
        return true;
      } else {
        return false;
      }
    }
  };
  const user = useSelector((appState: ApplicationState) => appState.user);
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      !loyalty.withdraw.loading &&
      !loyalty.withdraw.error &&
      user.roles.loyaltyCustomers
    ) {
      dispatch(loadLoyaltyWithdraw(user.roles.loyaltyCustomers));
    }
  }, [user.userPermissions.hasLoyaltyAccess]);
  const history = useHistory();
  return (
    <div>
      {loyalty.withdraw.loading && <Skeleton />}
      {!loyalty.withdraw.loading && loyalty.withdraw.error && (
        <div>
          <Skeleton />
          <Dialog
            dialogSize="sm"
            textContent={
              'Desculpe, ocorreu um problema ao buscar seus dados de resgate.'
            }
            actions={{
              right: {
                name: 'back',
                children: 'Ok',
                onClick: () => {
                  history.push(
                    `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_HOW_WORKS}`
                  );
                }
              }
            }}
          />
        </div>
      )}
      {!loyalty.withdraw.loading &&
        !loyalty.withdraw.error &&
        areRewardsAvailable() && <RewardsAvailable />}
      {!loyalty.withdraw.loading &&
        !loyalty.withdraw.error &&
        !areRewardsAvailable() && <NoRewardsAvailable coinTotal={coinTotal} />}
    </div>
  );
};

export default LoyaltyRewards;
